export const Icon1 = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.625 16.3125H14.5294C3.47624 15.6769 1.90686 6.35063 1.68749 3.50438C1.66981 3.28308 1.69597 3.06046 1.76448 2.84929C1.83298 2.63812 1.94248 2.44255 2.0867 2.27377C2.23092 2.10499 2.40703 1.96632 2.60493 1.86572C2.80283 1.76512 3.01864 1.70456 3.23999 1.6875H6.33936C6.56468 1.68728 6.78486 1.75472 6.97141 1.88109C7.15795 2.00746 7.30225 2.18693 7.38561 2.39625L8.24061 4.5C8.32293 4.7045 8.34336 4.92867 8.29936 5.14468C8.25536 5.36068 8.14887 5.559 7.99311 5.715L6.79499 6.92438C6.98214 7.98792 7.49146 8.96831 8.25405 9.73291C9.01664 10.4975 9.99569 11.0094 11.0587 11.1994L12.2794 9.99C12.4377 9.83596 12.6379 9.73195 12.855 9.69094C13.072 9.64993 13.2964 9.67373 13.5 9.75938L15.6206 10.6088C15.8268 10.6947 16.0027 10.8402 16.1259 11.0265C16.2491 11.2128 16.3141 11.4316 16.3125 11.655V14.625C16.3125 15.0726 16.1347 15.5018 15.8182 15.8182C15.5018 16.1347 15.0725 16.3125 14.625 16.3125ZM3.37499 2.8125C3.2258 2.8125 3.08273 2.87176 2.97724 2.97725C2.87175 3.08274 2.81249 3.22582 2.81249 3.375V3.42C3.07124 6.75 4.73061 14.625 14.5912 15.1875C14.6651 15.1921 14.7392 15.182 14.8092 15.1579C14.8792 15.1338 14.9438 15.0961 14.9991 15.0469C15.0545 14.9978 15.0997 14.9382 15.132 14.8716C15.1643 14.805 15.1832 14.7327 15.1875 14.6587V11.655L13.0669 10.8056L11.4525 12.4087L11.1825 12.375C6.28874 11.7619 5.62499 6.86813 5.62499 6.8175L5.59124 6.5475L7.18874 4.93313L6.34499 2.8125H3.37499Z"
        fill="#007FFF"
      />
    </svg>
  );
};

export const Profile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2Z"
        stroke="#007FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.27344 18.346C4.27344 18.346 6.50244 15.5 12.0024 15.5C17.5024 15.5 19.7324 18.346 19.7324 18.346"
        stroke="#007FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12C12.7956 12 13.5587 11.6839 14.1213 11.1213C14.6839 10.5587 15 9.79565 15 9C15 8.20435 14.6839 7.44129 14.1213 6.87868C13.5587 6.31607 12.7956 6 12 6C11.2044 6 10.4413 6.31607 9.87868 6.87868C9.31607 7.44129 9 8.20435 9 9C9 9.79565 9.31607 10.5587 9.87868 11.1213C10.4413 11.6839 11.2044 12 12 12V12Z"
        stroke="#007FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Sort = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 16V14H6V16H0ZM0 9V7H12V9H0ZM0 2V0H18V2H0Z" fill="#2F80ED" />
    </svg>
  );
};

export const Settings = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0774 1.5C14.2362 1.50001 14.3909 1.55041 14.5192 1.64394C14.6475 1.73748 14.7429 1.86933 14.7914 2.0205L15.6164 4.584C15.9629 4.7535 16.2944 4.944 16.6109 5.1585L19.2449 4.5915C19.4002 4.55834 19.5621 4.57534 19.7071 4.64003C19.8521 4.70473 19.9729 4.81379 20.0519 4.9515L22.1309 8.55C22.2103 8.68763 22.244 8.84693 22.227 9.0049C22.21 9.16288 22.1433 9.31139 22.0364 9.429L20.2289 11.424C20.2553 11.8065 20.2553 12.1905 20.2289 12.573L22.0364 14.571C22.1433 14.6886 22.21 14.8371 22.227 14.9951C22.244 15.1531 22.2103 15.3124 22.1309 15.45L20.0519 19.05C19.9727 19.1874 19.8518 19.2962 19.7068 19.3606C19.5618 19.425 19.4001 19.4418 19.2449 19.4085L16.6109 18.8415C16.2959 19.0545 15.9629 19.2465 15.6179 19.416L14.7914 21.9795C14.7429 22.1307 14.6475 22.2625 14.5192 22.3561C14.3909 22.4496 14.2362 22.5 14.0774 22.5H9.91945C9.76066 22.5 9.60598 22.4496 9.47766 22.3561C9.34935 22.2625 9.25404 22.1307 9.20545 21.9795L8.38195 19.4175C8.03638 19.2485 7.70306 19.0555 7.38445 18.84L4.75195 19.4085C4.59665 19.4417 4.43483 19.4247 4.2898 19.36C4.14478 19.2953 4.02403 19.1862 3.94495 19.0485L1.86595 15.45C1.78657 15.3124 1.75294 15.1531 1.76992 14.9951C1.78691 14.8371 1.85362 14.6886 1.96045 14.571L3.76795 12.573C3.74177 12.1914 3.74177 11.8086 3.76795 11.427L1.96045 9.429C1.85362 9.31139 1.78691 9.16288 1.76992 9.0049C1.75294 8.84693 1.78657 8.68763 1.86595 8.55L3.94495 4.95C4.02425 4.81256 4.14509 4.70381 4.2901 4.63939C4.43511 4.57497 4.59681 4.55821 4.75195 4.5915L7.38445 5.16C7.70245 4.9455 8.03545 4.752 8.38195 4.5825L9.20695 2.0205C9.25538 1.86982 9.35024 1.73832 9.47795 1.64482C9.60566 1.55133 9.75968 1.50064 9.91795 1.5H14.0759H14.0774ZM13.5284 3H10.4684L9.61645 5.6505L9.04195 5.931C8.75953 6.06921 8.48689 6.22657 8.22595 6.402L7.69495 6.762L4.97095 6.174L3.44095 8.826L5.30845 10.893L5.26345 11.529C5.2419 11.8426 5.2419 12.1574 5.26345 12.471L5.30845 13.107L3.43795 15.174L4.96945 17.826L7.69345 17.2395L8.22445 17.598C8.48539 17.7734 8.75803 17.9308 9.04045 18.069L9.61495 18.3495L10.4684 21H13.5314L14.3864 18.348L14.9594 18.069C15.2416 17.9311 15.5137 17.7737 15.7739 17.598L16.3034 17.2395L19.0289 17.826L20.5589 15.174L18.6899 13.107L18.7349 12.471C18.7566 12.1569 18.7566 11.8416 18.7349 11.5275L18.6899 10.8915L20.5604 8.826L19.0289 6.174L16.3034 6.759L15.7739 6.402C15.5138 6.22622 15.2416 6.06884 14.9594 5.931L14.3864 5.652L13.5299 3H13.5284ZM11.9984 7.5C13.1919 7.5 14.3365 7.97411 15.1804 8.81802C16.0243 9.66193 16.4984 10.8065 16.4984 12C16.4984 13.1935 16.0243 14.3381 15.1804 15.182C14.3365 16.0259 13.1919 16.5 11.9984 16.5C10.805 16.5 9.66038 16.0259 8.81647 15.182C7.97256 14.3381 7.49845 13.1935 7.49845 12C7.49845 10.8065 7.97256 9.66193 8.81647 8.81802C9.66038 7.97411 10.805 7.5 11.9984 7.5ZM11.9984 9C11.2028 9 10.4397 9.31607 9.87713 9.87868C9.31452 10.4413 8.99845 11.2044 8.99845 12C8.99845 12.7956 9.31452 13.5587 9.87713 14.1213C10.4397 14.6839 11.2028 15 11.9984 15C12.7941 15 13.5572 14.6839 14.1198 14.1213C14.6824 13.5587 14.9984 12.7956 14.9984 12C14.9984 11.2044 14.6824 10.4413 14.1198 9.87868C13.5572 9.31607 12.7941 9 11.9984 9Z"
        fill="#007FFF"
      />
    </svg>
  );
};

export const ArrowRight = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.833L11.3333 8.49967L6 3.16634"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftArrow = () => {
  return <svg width="24" height="25" viewBox="0 0 24 25" />;
};
export const RedCircle = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="5" fill="#F36960" />
    </svg>
  );
};
export const BlueCircle = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="5" fill="#448DF2" />
    </svg>
  );
};
export const YellowCicle = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="5" fill="#F9A63A" />
    </svg>
  );
};
export const Search = () => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 11.5006H7.14L10.77 7.14061C10.9397 6.93639 11.0214 6.67311 10.997 6.40869C10.9726 6.14426 10.8442 5.90035 10.64 5.73061C10.4358 5.56087 10.1725 5.47921 9.90808 5.50359C9.64365 5.52797 9.39974 5.65639 9.23 5.86061L4.23 11.8606C4.19636 11.9083 4.16628 11.9585 4.14 12.0106C4.14 12.0606 4.14 12.0906 4.07 12.1406C4.02467 12.2553 4.00094 12.3773 4 12.5006C4.00094 12.6239 4.02467 12.746 4.07 12.8606C4.07 12.9106 4.07 12.9406 4.14 12.9906C4.16628 13.0428 4.19636 13.0929 4.23 13.1406L9.23 19.1406C9.32402 19.2535 9.44176 19.3443 9.57485 19.4065C9.70793 19.4687 9.85309 19.5008 10 19.5006C10.2337 19.5011 10.4601 19.4197 10.64 19.2706C10.7413 19.1867 10.825 19.0836 10.8863 18.9672C10.9477 18.8509 10.9855 18.7236 10.9975 18.5926C11.0096 18.4616 10.9957 18.3295 10.9567 18.2039C10.9176 18.0783 10.8542 17.9617 10.77 17.8606L7.14 13.5006H19C19.2652 13.5006 19.5196 13.3953 19.7071 13.2077C19.8946 13.0202 20 12.7658 20 12.5006C20 12.2354 19.8946 11.981 19.7071 11.7935C19.5196 11.606 19.2652 11.5006 19 11.5006Z"
        fill="#007FFF"
      />
    </svg>
  );
};

export const ListIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6562 17.7812H6.6875C6.56719 17.7812 6.46875 17.8797 6.46875 18V19.5312C6.46875 19.6516 6.56719 19.75 6.6875 19.75H22.6562C22.7766 19.75 22.875 19.6516 22.875 19.5312V18C22.875 17.8797 22.7766 17.7812 22.6562 17.7812ZM22.6562 2.25H6.6875C6.56719 2.25 6.46875 2.34844 6.46875 2.46875V4C6.46875 4.12031 6.56719 4.21875 6.6875 4.21875H22.6562C22.7766 4.21875 22.875 4.12031 22.875 4V2.46875C22.875 2.34844 22.7766 2.25 22.6562 2.25ZM22.6562 10.0156H6.6875C6.56719 10.0156 6.46875 10.1141 6.46875 10.2344V11.7656C6.46875 11.8859 6.56719 11.9844 6.6875 11.9844H22.6562C22.7766 11.9844 22.875 11.8859 22.875 11.7656V10.2344C22.875 10.1141 22.7766 10.0156 22.6562 10.0156ZM3.40625 16.4688H0.234375C0.174219 16.4688 0.125 16.518 0.125 16.5781V17.5078C0.125 17.568 0.174219 17.6172 0.234375 17.6172H2.21406V18.1777H1.23789C1.17773 18.1777 1.12852 18.227 1.12852 18.2871V19.2168C1.12852 19.277 1.17773 19.3262 1.23789 19.3262H2.21406V19.9141H0.234375C0.174219 19.9141 0.125 19.9633 0.125 20.0234V20.9531C0.125 21.0133 0.174219 21.0625 0.234375 21.0625H3.40625C3.46641 21.0625 3.51562 21.0133 3.51562 20.9531V16.5781C3.51562 16.518 3.46641 16.4688 3.40625 16.4688ZM0.234375 2.14062H1.27344V5.42188C1.27344 5.48203 1.32266 5.53125 1.38281 5.53125H2.47656C2.53672 5.53125 2.58594 5.48203 2.58594 5.42188V1.15625C2.58594 1.03594 2.4875 0.9375 2.36719 0.9375H0.234375C0.174219 0.9375 0.125 0.986719 0.125 1.04688V2.03125C0.125 2.09141 0.174219 2.14062 0.234375 2.14062ZM3.40625 8.70312H0.234375C0.174219 8.70312 0.125 8.75234 0.125 8.8125V9.79688C0.125 9.85703 0.174219 9.90625 0.234375 9.90625H2.10469L0.182422 12.0309C0.146166 12.0716 0.125782 12.124 0.125 12.1785V13.1875C0.125 13.2477 0.174219 13.2969 0.234375 13.2969H3.40625C3.46641 13.2969 3.51562 13.2477 3.51562 13.1875V12.2031C3.51562 12.143 3.46641 12.0938 3.40625 12.0938H1.53594L3.4582 9.96914C3.49446 9.92842 3.51484 9.876 3.51562 9.82148V8.8125C3.51562 8.75234 3.46641 8.70312 3.40625 8.70312Z"
        fill="#007FFF"
      />
    </svg>
  );
};

export const NotSelectedRadio = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="11" r="10.5" fill="#C4C4C4" />
    </svg>
  );
};
export const SelectedRadio = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="11" r="10.5" fill="#007FFF" />
      <path
        d="M7 11.5L10 14.5L15 8.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SupplierCardIcon = () => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="36" height="36" rx="18" fill="#BBD8FF" />
      <path
        d="M15.868 20.64H12.22L11.548 22.5H10.396L13.42 14.184H14.68L17.692 22.5H16.54L15.868 20.64ZM15.556 19.752L14.044 15.528L12.532 19.752H15.556ZM24.6019 16.584C24.6019 17.28 24.3619 17.86 23.8819 18.324C23.4099 18.78 22.6859 19.008 21.7099 19.008H20.1019V22.5H19.0099V14.136H21.7099C22.6539 14.136 23.3699 14.364 23.8579 14.82C24.3539 15.276 24.6019 15.864 24.6019 16.584ZM21.7099 18.108C22.3179 18.108 22.7659 17.976 23.0539 17.712C23.3419 17.448 23.4859 17.072 23.4859 16.584C23.4859 15.552 22.8939 15.036 21.7099 15.036H20.1019V18.108H21.7099Z"
        fill="black"
      />
    </svg>
  );
};
export const SortUp = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25095 18.7502C5.25095 18.9491 5.17193 19.1398 5.03128 19.2805C4.89063 19.4211 4.69986 19.5002 4.50095 19.5002C4.30204 19.5002 4.11127 19.4211 3.97062 19.2805C3.82997 19.1398 3.75095 18.9491 3.75095 18.7502V5.56066L2.03195 7.28116C1.96222 7.3509 1.87943 7.40621 1.78832 7.44395C1.69721 7.48169 1.59956 7.50111 1.50095 7.50111C1.40233 7.50111 1.30468 7.48169 1.21357 7.44395C1.12246 7.40621 1.03968 7.3509 0.969947 7.28116C0.900215 7.21143 0.844901 7.12865 0.807162 7.03754C0.769424 6.94643 0.75 6.84878 0.75 6.75016C0.75 6.65155 0.769424 6.5539 0.807162 6.46279C0.844901 6.37168 0.900216 6.2889 0.969947 6.21916L3.96995 3.22066L3.98045 3.21016C4.12145 3.07322 4.31074 2.99737 4.5073 2.99905C4.70385 3.00074 4.89181 3.07982 5.03045 3.21916L8.03045 6.21916C8.10018 6.2888 8.15551 6.37148 8.19329 6.4625C8.23107 6.55352 8.25055 6.65109 8.25062 6.74963C8.25069 6.84818 8.23134 6.94577 8.1937 7.03685C8.15605 7.12792 8.10083 7.21068 8.0312 7.28041C7.96156 7.35015 7.87888 7.40548 7.78786 7.44326C7.69684 7.48103 7.59927 7.50051 7.50073 7.50058C7.40218 7.50065 7.30459 7.48131 7.21352 7.44366C7.12244 7.40601 7.03968 7.3508 6.96995 7.28116L5.25095 5.56066V18.7502ZM10.5009 5.25016C10.5009 5.05125 10.58 4.86049 10.7206 4.71983C10.8613 4.57918 11.052 4.50016 11.2509 4.50016H21.7509C21.9499 4.50016 22.1406 4.57918 22.2813 4.71983C22.4219 4.86049 22.5009 5.05125 22.5009 5.25016C22.5009 5.44908 22.4219 5.63984 22.2813 5.78049C22.1406 5.92115 21.9499 6.00016 21.7509 6.00016H11.2509C11.052 6.00016 10.8613 5.92115 10.7206 5.78049C10.58 5.63984 10.5009 5.44908 10.5009 5.25016ZM11.2509 9.00016C11.052 9.00016 10.8613 9.07918 10.7206 9.21983C10.58 9.36049 10.5009 9.55125 10.5009 9.75016C10.5009 9.94908 10.58 10.1398 10.7206 10.2805C10.8613 10.4211 11.052 10.5002 11.2509 10.5002H18.7509C18.9499 10.5002 19.1406 10.4211 19.2813 10.2805C19.4219 10.1398 19.5009 9.94908 19.5009 9.75016C19.5009 9.55125 19.4219 9.36049 19.2813 9.21983C19.1406 9.07918 18.9499 9.00016 18.7509 9.00016H11.2509ZM11.2509 13.5002C11.052 13.5002 10.8613 13.5792 10.7206 13.7198C10.58 13.8605 10.5009 14.0513 10.5009 14.2502C10.5009 14.4491 10.58 14.6398 10.7206 14.7805C10.8613 14.9211 11.052 15.0002 11.2509 15.0002H15.7509C15.9499 15.0002 16.1406 14.9211 16.2813 14.7805C16.4219 14.6398 16.5009 14.4491 16.5009 14.2502C16.5009 14.0513 16.4219 13.8605 16.2813 13.7198C16.1406 13.5792 15.9499 13.5002 15.7509 13.5002H11.2509ZM11.2509 18.0002C11.052 18.0002 10.8613 18.0792 10.7206 18.2198C10.58 18.3605 10.5009 18.5513 10.5009 18.7502C10.5009 18.9491 10.58 19.1398 10.7206 19.2805C10.8613 19.4211 11.052 19.5002 11.2509 19.5002H12.7509C12.9499 19.5002 13.1406 19.4211 13.2813 19.2805C13.4219 19.1398 13.5009 18.9491 13.5009 18.7502C13.5009 18.5513 13.4219 18.3605 13.2813 18.2198C13.1406 18.0792 12.9499 18.0002 12.7509 18.0002H11.2509Z"
        fill="#717171"
      />
    </svg>
  );
};
export const SortAlphaUp = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1244 8.44345L14.4974 10.5H12.8984L15.5819 2.50195H17.4329L20.1044 10.5H18.4244L17.7959 8.44345H15.1244ZM17.4794 7.26595L16.5014 4.03045H16.4309L15.4529 7.26595H17.4794Z"
        fill="#717171"
      />
      <path
        d="M19.4409 21.0002H13.5429V19.9637L17.4114 14.3837V14.3027H13.6479V13.0022H19.3254V14.0387L15.4749 19.6187V19.6997H19.4424V21.0002H19.4409ZM6.75095 20.2502C6.75095 20.4491 6.67193 20.6398 6.53128 20.7805C6.39063 20.9211 6.19986 21.0002 6.00095 21.0002C5.80204 21.0002 5.61127 20.9211 5.47062 20.7805C5.32997 20.6398 5.25095 20.4491 5.25095 20.2502V5.56066L3.53195 7.28116C3.46222 7.3509 3.37943 7.40621 3.28832 7.44395C3.19721 7.48169 3.09956 7.50111 3.00095 7.50111C2.90233 7.50111 2.80468 7.48169 2.71357 7.44395C2.62246 7.40621 2.53968 7.3509 2.46995 7.28116C2.40022 7.21143 2.3449 7.12865 2.30716 7.03754C2.26942 6.94643 2.25 6.84878 2.25 6.75016C2.25 6.65155 2.26942 6.5539 2.30716 6.46279C2.3449 6.37168 2.40022 6.2889 2.46995 6.21916L5.46995 3.22066L5.48045 3.21016C5.62145 3.07322 5.81074 2.99737 6.0073 2.99905C6.20385 3.00074 6.39181 3.07982 6.53045 3.21916L9.53045 6.21916C9.60018 6.2888 9.65551 6.37148 9.69329 6.4625C9.73107 6.55352 9.75055 6.65109 9.75062 6.74963C9.75069 6.84818 9.73134 6.94577 9.6937 7.03685C9.65605 7.12792 9.60083 7.21068 9.5312 7.28041C9.46156 7.35015 9.37888 7.40548 9.28786 7.44326C9.19684 7.48103 9.09927 7.50051 9.00073 7.50058C8.90218 7.50065 8.80459 7.48131 8.71352 7.44366C8.62244 7.40601 8.53968 7.3508 8.46995 7.28116L6.75095 5.56066V20.2502Z"
        fill="#717171"
      />
    </svg>
  );
};

export const TrashRedIcon = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4.98045C15.67 4.65046 12.32 4.48047 8.98 4.48047C7 4.48047 5.02 4.58047 3.04 4.78046L1 4.98045"
        stroke="#F36960"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.49951 3.96991L6.71951 2.65995C6.87951 1.70998 6.99951 1 8.68951 1H11.3095C12.9995 1 13.1295 1.74998 13.2795 2.66995L13.4995 3.96991"
        stroke="#F36960"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.8514 8.14062L16.2014 18.2103C16.0914 19.7803 16.0014 21.0002 13.2114 21.0002H6.79137C4.00137 21.0002 3.91137 19.7803 3.80137 18.2103L3.15137 8.14062"
        stroke="#F36960"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33105 15.5H11.6611"
        stroke="#F36960"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.49902 11.5H12.499"
        stroke="#F36960"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Bill = () => {
  return <svg width="14" height="14" viewBox="0 0 14 14" />;
};
export const Notification = () => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9999 3.33208V4.74299C12.9999 5.66416 12.3999 6.24718 11.4519 6.24718H9.3999V2.17187C9.3999 1.52472 9.94591 1 10.6119 1C11.2659 1.00583 11.8659 1.26236 12.2979 1.68213C12.7299 2.10774 12.9999 2.69076 12.9999 3.33208Z"
        stroke="#2F80ED"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 3.9151V12.0774C1 12.5613 1.56399 12.8353 1.95999 12.5438L2.986 11.7975C3.226 11.6226 3.562 11.6459 3.778 11.8558L4.77399 12.8295C5.00799 13.0568 5.39201 13.0568 5.62601 12.8295L6.63401 11.85C6.84401 11.6459 7.18 11.6226 7.414 11.7975L8.44001 12.5438C8.83601 12.8295 9.4 12.5554 9.4 12.0774V2.16604C9.4 1.52472 9.94 1 10.6 1H4H3.4C1.6 1 1 2.0436 1 3.33208V3.9151Z"
        stroke="#2F80ED"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.3999 5.08154H6.9999"
        stroke="#2F80ED"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.8501 7.41357H6.5501"
        stroke="#2F80ED"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
